/**
 * Created by Administrator on 2019/7/15.
 */
import $$ from "jquery";
import appConfig from "@/config/app"; //引入配置文件
let JX_KEY = '680073321622AA17';
//是否开发者模式
let JX_BASE_URL = appConfig.thirdApi.jx;

const JxApi = {
    /*******************************以下是精讯接口 **************************************/
    //查询采集器的单个节点
    selSingleSensorData(deviceNumber, eid,succFun,failFun){
        var wire=eid.split('-')[2];
        var url = JX_BASE_URL + "selSingleSensorData?secretKey=" + JX_KEY + "&sensorId=" + deviceNumber + wire;
        JxApi.ajax('获取采集器的单个传感器数据', url,  function (res) {
            if (res.state == 'success') {
                res.eqmsg=this.sensorData(eid)[0];
                res.eqmsg.value=res.data,
                succFun(res)
            } else {
                failFun(res.msg)
            }
        }, function (err) {
            failFun(err)
        })
    },
    /**
     * 功能描述: 顺带判断 继电器/传感器工作是否正常 是否为开（继电器只有有一个开即为开）
     */
    getDeviceInfo(deviceNumber, eid, succFunc, failFunc){
        var url = JX_BASE_URL + "getDeviceInfo?secretKey=" + JX_KEY + "&deviceNumber=" + deviceNumber;
        JxApi.ajax('获取设备信息', url, function (res) {
            if (res.state == 'success') {
                res.broken = false;
                res.isOpen = false;
                // 离线就必定关？
                if (res.data.onLineState == 0) {
                    res.isOpen = false;
                } else {
                    // 继电器只有有一个开即为开
                    if (this.isRelay(eid)) {
                        var switchArr = res.data.data.split('|');
                        switchArr.map(function (item) {
                            res.isOpen = res.isOpen || item == '开';
                        })
                    } else {
                        res.isOpen = true;
                    }
                }

            } else {
                res.broken = true;
                res.isOpen = false;
            }
            succFunc(res)
        }, failFunc)
    },
    /**
     * 功能描述: 关闭/开启单路 继电器
     */
    onOffRelay(deviceNumber, wire, isOpen, succFunc, failFunc){
        var command = getRelayCommand(wire, isOpen);
        this.selRelayCommand(deviceNumber, command, succFunc, failFunc);
    },
    //7.对继电器设备下发开关指令
    selRelayCommand(deviceNumber,command,fn,fn2){
        let url =JX_BASE_URL+'selRelayCommand?secretKey='+JX_KEY+
            'deviceNumber='+deviceNumber+'command='+command;
            JxApi.ajax('精讯-继电器设备下发开关指令',url,fn,fn2)
    },
    //5.根据日期查询设备历史记录接口
    selHistoryForDate(deviceNumber,page,size,startTime,endTime,fn,fn2){
        JxApi.ajax('精讯-查询设备历史记录',JX_BASE_URL+'selHistoryForDate?secretKey='+JX_KEY+
            'deviceNumber='+deviceNumber+'page='+page+'size='+size+'startTime='+startTime+'endTime='+endTime,fn,fn2)
    },

    // 6、查询设备节点数据接口
    selSensorData(deviceNumber,fn,fn2){
        JxApi.ajax('查询设备节点数据接口',JX_BASE_URL+'selSensorData?secretKey='+JX_KEY+
            'deviceNumber='+deviceNumber,fn,fn2)
    },

    // 1、从平台获取设备列表
    getDeviceList(fn,fn2){
        JxApi.ajax('从平台获取设备列表',JX_BASE_URL+'getDeviceList?secretKey='+JX_KEY,fn,fn2)
    },
    /**
     * ajax提交封装
     * @param description ：功能描述，便于提示信息容易理解，如：首页公告获取、商品信息获取等等
     * @param command ：具体指令
     * @param fn ：回调函数，返回JSON对象或者异常信息，接口请求异常时返回null，接口请求不通时返回error，外部调用需判断是否为null或者error
     * @param fn2 ：异步请求方法类型 默认post
     *
     *
     */
    ajax: function (description,url, fn, fn2) {

        //发起ajax

        var result;
        console.log(url);
        // $$.getScript(url, function () {
        //     console.log(data);
        // });
        $$.ajax({
            url:url,
            type:'GET',
            timeout:10000,
            dataType:'jsonp',
            jsonp: 'callback',
            success:function(response){
                console.log('成功');
                console.log(response);
                if (typeof fn == "function") fn(response);
            },error:function(xhr,textStatus){
                console.log('失败');
                if (typeof fn2 == "function") fn2(xhr,textStatus);
            }
        });
        // $$.ajax({
        //     type: "GET",    //请求类型
        //     dataType: "script",
        //     url: url,
        //     // headers:{'Access-Control-Allow-Origin': '*'},
        //     success: function (data) {
        //         //回调结果，如果成功
        //         result = data;
        //         console.log('成功');
        //         console.log(result);
        //         if (typeof fn == "function")  fn(result);
        //     },
        //     error: function (XMLHttpRequest, textStatus, errorThrown) {
        //         console.log('失败');
        //         if (typeof fn2 == "function") fn2('失败')
        //     }, complete: function (XMLHttpRequest, textStatus) {
        //         console.log('************************ 精讯 请求 start ************************');
        //         console.log('接口描述：' + description);
        //         console.log('请求URL：' + url);
        //         console.log('你的参数：' + JSON.stringify(data));
        //         if (result) {
        //             console.log('接口返回：' + JSON.stringify(result));
        //         } else {
        //             console.log('接口返回：' + '没有返回结果');
        //         }
        //         console.log('************************ 请求结束 end ************************');
        //     }
        // });


    },
    /**
     * 功能描述: 根据mac获取继电器的状态
     */
    getRelayStatus(deviceNumber,succFunc,failFunc){

        JxApi.getDeviceInfo(deviceNumber,function (data) {
        var obj='';
        if (data.state=='success'){
            var tempList=[];
            var datas=data.data.split('|');
            datas.forEach(function (item) {
                tempList.push(item=='开')
            })
            succFunc()
        }
    },function (err) {

    });
},
/**
 *
 * 功能描述: 一键开启关闭  目前只有16路
 */
onKeyOnOff(deviceNumber,isOpen){
    var succCount=0;
    for (var  wire=1;i<=16;i++){
        var command=getRelayCommand(wire,isOpen);
        JxApi.selRelayCommand(deviceNumber,command,function (ret) {
            succCount++
        },function (err) {
        });
    }
},

/**
 * 功能描述: 关闭/开启单路 继电器
 */
onOffRelay(deviceNumber,wire,isOpen,succFunc,failFunc){
    var command=getRelayCommand(wire,isOpen);
    JxApi.selRelayCommand(deviceNumber,command,succFunc,failFunc);
},
    getRelayCommand( wire,isOpen){
        if (wire<1){
            console.log("线路不能小于1");
            return
        }
        if (wire<10){
            wire="0"+wire;
        }
        return wire+(isOpen?"01":"00");
    },
    // isRelay(eid) {
    //     return eid.indexOf('relay') != -1;
    // },
    // sensorData(eid) {
    //     var type;
    //     if(eid.split('-').length>1){
    //         type=eid.split('-')[1];
    //     }else{
    //         type=eid;
    //     }
    //     var sensor;
    //     switch(type){
    //         case 'sw': sensor=[{'name':'水位','value':'', 'union':'M'}]; break;
    //         case 'sd': sensor=[{'name':'湿度','value':'', 'union':'%RH'}]; break;
    //         case 'wd': sensor=[{'name':'温度','value':'', 'union':'℃'}]; break;
    //         case 'yf': sensor=[{'name':'盐份','value':'', 'union':'us/cm'}]; break;
    //         case 'rjy': sensor=[{'name':'溶解氧','value':'', 'union':''}]; break;
    //         case 'ph': sensor=[{'name':'ph','value':'', 'union':''}]; break;
    //         case 'hw': sensor=[{'name':'红外','value':'', 'union':''}]; break;
    //         case 'gzd': sensor=[{'name':'光照度','value':'', 'union':''}]; break;
    //         case 'zs': sensor=[{'name':'噪声','value':'', 'union':''}]; break;
    //
    //         case '24': sensor=[{'name':'水位','value':'', 'union':'M'}]; break;
    //         case '3': sensor=[{'name':'温度','value':'', 'union':'℃'}]; break;
    //         case '5':
    //         case '15': sensor=[
    //             {"name":"湿度","value":'','union':'%RH'},
    //             {"name":"温度","value":'','union':'°C'}
    //         ]; break;
    //         case '4': sensor=[{"name":"湿度","value":'','union':'%RH'},
    //             {"name":"温度","value":'','union':'°C'},
    //             {"name":"盐度","value":'','union':'us/cm'}]; break;
    //     }
    //
    //     return sensor;
    // },
}



export default JxApi;